import { http } from '@/utils/http'

export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

/**
 * 修改H5端配置的方法
 */
export const saveH5Configs = async (configs) => {
  return new Promise((resolve, reject) => {
    http.post(`${BPBASE}/channel/h5/saveH5Configs`, { data: configs }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取h5数据列表
 */
export const getH5ConfigsPaged = async (params) => {
  params.platformId = 'h5'
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/channel/h5/getH5ConfigsPaged`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据channelId获取h5数据
 */
export const getH5ConfigsById = async ({ id }) => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/channel/h5/getH5ConfigsById`, { params: { id } }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const deleteH5Configs = async ({ id }) => {
  return new Promise((resolve, reject) => {
    http.delete(`${BPBASE}/channel/h5/deleteH5Configs`, { params: { id } }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
